import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const AddGroupFormSchema = z.object({
  groupNumber: z.number().optional(),
  namespace: z.enum(['cnx', 'frg'], { message: 'Namespace must be cnx or frg' }),
  organization: z.string().min(1, 'Organization is required').max(100),
  groupName: z.string().min(2, 'Group name must be at least 2 characters').max(100),
  groupDescription: z.string().max(500).optional().default(''),
  roles: z.array(z.string()).default([]),
  members: z.array(z.string()).default([]),
})

export type AddGroupFormData = z.infer<typeof AddGroupFormSchema>

export function transformToApiRequest(formData: AddGroupFormData) {
  return {
    groupNumber: formData.groupNumber,
    namespace: formData.namespace,
    organization: formData.organization.trim(),
    groupName: formData.groupName.trim(),
    groupDescription: formData.groupDescription?.trim() ?? '',
    roles: formData.roles ?? [],
    members: formData.members ?? [],
  }
}
